import { useDataValue, useDataChange } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let change = useDataChange({
    context: 'tab',
    path: 'selected.board_submenu_tab_id',
    viewPath: props.viewPath,
  })
  let menu_item_id = useDataValue({
    context: 'menu_item',
    path: 'id',
    viewPath: props.viewPath,
  })

  let board_id = useDataValue({
    context: 'tab',
    path: 'selected.board_id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    // prevent other sections being opened if it's a new board
    if (board_id === 'new' && menu_item_id !== 'Settings') return false

    change(menu_item_id)
    setFlowTo(normalizePath(props.viewPath, `../../../Main/${menu_item_id}`))
  }
}

export function isDisabled(board_id, id) {
  // settings is never disabled
  if (id === 'Settings') return false
  // others are disabled if it's a new board
  if (board_id === 'new') return true
}
